import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Products from './pages/Products';
import CartPage from './pages/CartPage';

import ProductPage from './components/ProductPage';
import Cart from './components/Cart';
import Aboutus from './components/Aboutus';
import Contact from './components/Contact';
import { BrowserRouter } from 'react-router-dom';

import UserMaster from './admin/Pages/UserMaster';
import ProductMaster from './admin/Pages/ProductMaster';
import OrderMaster from './admin/Pages/OrderMaster';
import ContactMaster from './admin/Pages/ContactMaster';
import Login from './admin/Pages/Login';
import Sidebar from './admin/Pages/Sidebar';

// User auth components
import LoginUser from './components/Login';
import Register from './components/Register';
import MyOrders from './components/MyOrders';
import ProfilePage from './components/ProfilePage';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import {
  setLoginStatus,
  setUserDetails,
  setUserId,
} from './redux/authSlice';

function App() {
  const loggedInStatus = useSelector(
    (state) => state.auth.loggedInStatus
  );

  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.auth.userDetails);

  const ProtectedRouteForUsers = ({ children }) => {
    if (userDetails?.role === 'user') {
      return <Navigate to='/loginadmin' />;
    }
    return children;
  };

  const ProtectedRouteForAdmin = ({ children }) => {
    if (userDetails?.role === 'admin') {
      dispatch(setLoginStatus(false));
      dispatch(setUserDetails({}));
      dispatch(setUserId(''));
      return <Navigate to='/login' />;
    }
    return children;
  };

  const ProtectedRouteForUsersIfNotLogin = ({ children }) => {
    if (!loggedInStatus) {
      return <Navigate to='/login' />;
    }
    return children;
  };
  const ProtectedRouteForUsersIfNotLoginAndAccessingAdmin = ({
    children,
  }) => {
    if (!loggedInStatus) {
      return <Navigate to='/loginadmin' />;
    }
    return children;
  };

  // scroll to top function
  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          path='/'
          element={
            <ProtectedRouteForAdmin>
              <Header />
            </ProtectedRouteForAdmin>
          }
        >
          <Route index element={<Home />} />
          <Route path='/aboutus' element={<Aboutus />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/products' element={<Products />} />
          <Route
            path='/myorders'
            element={
              <ProtectedRouteForUsersIfNotLogin>
                <MyOrders />
              </ProtectedRouteForUsersIfNotLogin>
            }
          />
          <Route
            path='/cart'
            element={
              <ProtectedRouteForUsersIfNotLogin>
                <CartPage />
              </ProtectedRouteForUsersIfNotLogin>
            }
          />

          {/* <Route path="/product/:id" element={<ProductPage />} /> */}
          <Route
            path='/profile'
            element={
              <ProtectedRouteForUsersIfNotLogin>
                <ProfilePage />
              </ProtectedRouteForUsersIfNotLogin>
            }
          />

          <Route
            path='/product/:id'
            element={
              <ProtectedRouteForUsersIfNotLogin>
                <ProductPage />
              </ProtectedRouteForUsersIfNotLogin>
            }
          />
          <Route
            path='/cart/:productId/:quantity'
            element={
              <ProtectedRouteForUsersIfNotLogin>
                <Cart />
              </ProtectedRouteForUsersIfNotLogin>
            }
          />

          <Route path='/login' element={<LoginUser />} />
          <Route path='/register' element={<Register />} />
          {/* <Route path="/product/:id" element={<ProductPage />} /> */}
          {/* <Route path="/checkout" element={<CheckoutPage />} /> */}
          {/* Add profile and orders routes */}
          <Route
            path='/profile'
            element={
              <div className='py-8'>
                <h1 className='text-3xl font-bold'>My Profile</h1>
              </div>
            }
          />
          <Route
            path='/orders'
            element={
              <div className='py-8'>
                <h1 className='text-3xl font-bold'>My Orders</h1>
              </div>
            }
          />
        </Route>

        <Route
          path='/admin'
          element={
            <ProtectedRouteForUsersIfNotLoginAndAccessingAdmin>
              <ProtectedRouteForUsers>
                <Sidebar />
              </ProtectedRouteForUsers>
            </ProtectedRouteForUsersIfNotLoginAndAccessingAdmin>
          }
        >
          <Route index element={<UserMaster />} />
          <Route path='productmaster' element={<ProductMaster />} />
          <Route path='ordermaster' element={<OrderMaster />} />
          <Route path='contactmaster' element={<ContactMaster />} />
        </Route>

        <Route path='/loginadmin' element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
